export default __webpack_public_path__ + "static/media/NYC_BG_Horizontal.0d7e0030.svg";